import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function GiftVouchers() {
  return (
    <div className="bg-[#FAFAF8] text-[#1C1C1A] min-h-screen">
      <Helmet>
        <title>Houseboat Gift Vouchers — Ireland | Aquastays</title>
        <meta name="description" content="Give a night on Lough Ree. Printable or posted gift vouchers for a houseboat stay at Inner Lakes Marina, Athlone — a unique experience gift for any occasion." />
        <link rel="canonical" href="https://aquastays.com/gift-vouchers" />
      </Helmet>

      <Header solid />

      <main className="max-w-[860px] mx-auto px-6 sm:px-10 py-20 sm:py-28">
        <p className="eyebrow text-[#6B6B65] mb-4">Give an experience</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light text-[#1C1C1A] tracking-tight leading-tight mb-6">
          Houseboat gift vouchers.
        </h1>
        <p className="text-sm text-[#6B6B65] font-light leading-relaxed mb-10 max-w-xl">
          Give someone a night — or two — on Lough Ree. An Aquastays gift voucher is a genuinely different present: a boutique houseboat on still inland waters, just 75 minutes from Dublin. Perfect for birthdays, anniversaries, Christmas or just because.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-14">
          <div className="bg-white border border-[#1C1C1A]/8 p-7">
            <p className="eyebrow text-[#E8970A] mb-3">1 night</p>
            <p className="font-serif text-3xl font-light text-[#1C1C1A] mb-3">From €180</p>
            <p className="text-sm text-[#6B6B65] font-light leading-relaxed">
              A single-night escape. Arrive in the afternoon, wake to the water, depart before noon. Includes all linen, Wi-Fi, heating and parking.
            </p>
          </div>
          <div className="bg-white border border-[#1C1C1A]/8 p-7">
            <p className="eyebrow text-[#E8970A] mb-3">2 nights</p>
            <p className="font-serif text-3xl font-light text-[#1C1C1A] mb-3">From €340</p>
            <p className="text-sm text-[#6B6B65] font-light leading-relaxed">
              Two nights lets you settle in, explore the lake and surrounding area properly. The experience most of our guests choose.
            </p>
          </div>
        </div>

        <div className="bg-[#F5F3EE] border border-[#1C1C1A]/8 p-8 mb-14">
          <h2 className="font-medium text-[#1C1C1A] text-base mb-3">How it works</h2>
          <ul className="space-y-2 text-sm text-[#6B6B65] font-light leading-relaxed">
            <li>1. Email us with the value, occasion and your name.</li>
            <li>2. We'll send a printable PDF voucher, or post a card version if you prefer.</li>
            <li>3. The recipient books a date that suits them — vouchers are valid for 12 months.</li>
            <li>4. Full flexibility: dates can be changed once at no charge.</li>
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
          <a
            href="mailto:dru@aquastays.com?subject=Gift%20Voucher%20Enquiry"
            className="flex items-center gap-2 px-7 py-3 rounded-full bg-[#E8970A] hover:bg-[#D08500] text-white font-semibold text-sm transition-colors"
          >
            <Mail size={14} /> Request a voucher
          </a>
          <Link to="/boats/aquastays-drift" className="text-[0.68rem] font-medium uppercase tracking-[0.18em] text-[#1C1C1A] hover:text-[#E8970A] transition-colors">
            See inside the houseboat →
          </Link>
        </div>

        <p className="mt-14 text-xs text-[#6B6B65]">
          Also see our <Link to="/faq" className="underline underline-offset-2 hover:text-[#1C1C1A]">FAQs</Link> and <Link to="/getting-here" className="underline underline-offset-2 hover:text-[#1C1C1A]">getting here guide</Link>.
        </p>
      </main>

      <Footer />
    </div>
  );
}
